import options from './splash-screen.component';

export default {
    selector: 'dtSplashScreen',
    options
};



// WEBPACK FOOTER //
// ./app/common/splash-screen/index.js